<template>
  <div>
    <ul class="System-1ist">
      <li class="System-item" v-for="(item, index) in currentSystemData" :key="index">
        <el-dialog title="收货地址" :visible.sync="item.dialogTableVisible" @close="pauseVideo(index)">
          <video width="100%" :ref="`video${index}`" controls>
            <source :src="item.video" type="video/mp4" />
            您的浏览器不支持 video 标签。
          </video>
        </el-dialog>
        <div class="System-img">
          <img :src="`http://demo.feixuns.com/images/img/${item.img}`" alt="" />
        </div>
        <div class="System-text">
          <h3 class="System-title">{{ item.title }}</h3>
          <div class="System-info">
            <p>
              <b>功能亮点：</b>
            </p>
            <span v-dompurify-html="item.info"> </span>
            <p class="System-user">
              用户名：<b>{{ item.userno }}</b
              >密码：<b>{{ item.psd }}</b>
              <template v-if="item.snum">
                APP短号：<b>{{ item.snum }}</b>
              </template>
            </p>
          </div>
          <div class="System-btns">
            <el-button v-if="item.bsurl" @click="openUrl(item.bsurl)" type="primary" plain>BS演示</el-button>
            <el-button v-if="item.appurl" @click="openUrl(item.appurl)">APP演示</el-button>
            <!--   <el-button v-if="item.operation_doc !== ''" @click="openUrl(item.operation_doc)">操作文档</el-button>
        <el-button v-if="item.video !== ''" @click="openVideo(item)">视频演示</el-button> -->
          </div>
        </div>
      </li>
    </ul>
    <el-pagination
      style="margin: 42px 0; text-align: center"
      background
      layout="prev, pager, next"
      :total="total"
      :page-size="5"
      @current-change="currentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "mesdemo",
  data() {
    return {
      total: 0,
      systemData: [],
      currentSystemData: [],
      info: "",
    };
  },
  props: {
    datalist: Array,
  },
  watch: {
    // 监听 datalist prop 的变化
    datalist: {
      handler(newVal) {
        // 当 datalist 变化时执行相应操作
        console.log("datalist updated:", newVal);
        this.systemData = newVal;
        this.total = this.systemData.length;
        this.currentSystemData = this.systemData.slice(0, 5);
        console.log("yy", this.currentSystemData);
      },
      deep: true,
    },
  },
  methods: {
    openUrl(url) {
      console.log(url);
      if (url == "" || url == null) {
        return false;
      } else {
        window.open(url, "_blank");
      }
    },
    currentChange(index) {
      this.currentSystemData = this.systemData.slice((index - 1) * 5, index * 5);
      console.log(this.currentSystemData);
      console.log(this.systemData);
    },
    openVideo(item) {
      //打开视频
      if (item.video == "" || item.video == null) {
        return false;
      } else {
        item.dialogTableVisible = true;
      }
    },
    pauseVideo(index) {
      //关闭视频操作
      let videoindex = `video${index}`;
      this.$refs[videoindex][0].currentTime = 0;
      this.$refs[videoindex][0].pause();
    },
  },
  created() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
